import { Toaster } from '@/components/ui/toaster'
import AuthHeader from './header'
import AuthContainer from './auth-container'
import AuthFromWrapper from './form-wraper'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

const VizAuth = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/auth') {
      navigate('/auth/login')
    }
  }, [location.pathname, navigate])

  return (
    <AuthContainer>
      <Toaster />

      <AuthHeader />
      <AuthFromWrapper>
        <Outlet />
      </AuthFromWrapper>
    </AuthContainer>
  )
}
export default VizAuth
